import FetchInterviews from '@Application/Beneficiaries/Interviews/Queries/FetchInterviews';
import fetchInterviews from '@Application/Beneficiaries/Interviews/fetchInterviews';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import type InterviewsListView from '@UI/Store/Interviews/Views/InterviewsListView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';
import type { UseStoreQueryResult } from '@verclam/synapse';

/**
 * The interviews of one dossier. Every reader of this list declares it here, so they share one cache
 * entry and one request.
 */
const useSubjectInterviews = (subject: SubjectAddress): UseStoreQueryResult<InterviewsListView | null> => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;

	return useStoreQuery({
		selector: (state) => state.interviewsStore.interviews,
		stopOn: (value) => value !== null && value.isFor(subject),
		query: () => dispatch(fetchInterviews(new FetchInterviews(facilityId, subject))),
		deps: [facilityId, subject],
	});
};

export default useSubjectInterviews;
